<!-- 修改字段名称 -->
<template>
  <h6 class="modifyFieldName" @click.stop="">
    <!-- v-if="roleState && roleState==='admin'&& userType === '0'" -->
    <template>
      <div class="fieldTitle" @click="editFild">{{fieldName}}<i class="icon-editfield"></i></div>
      <!-- 添加字段弹窗 -->
      <el-dialog title="" :visible.sync="visibility" :modal="true" :close-on-click-modal="true"
        class="commonDialog addDialog" :append-to-body="true" width="32%" ref="addDialog" @close="addCancelDialog">
        <div slot="title">
          <span class="title">编辑字段</span>
        </div>
        <div class="content">
          <el-form ref="modifyFieldForm" :model="form" :rules="rules" style="margin:0">
            <div class="top">
              <div class="row">
                <div class="filedKey">字段名称</div>
                <el-form-item label="" prop="newFieldName">
                  <el-input v-model="form.newFieldName" placeholder="填写需要展示的字段名"></el-input>
                </el-form-item>
              </div>
              <div class="row">
                <div class="filedKey">英文代码</div>
                <el-form-item label="">
                  <el-input disabled v-model="form.newFieldCode" placeholder=""></el-input>
                </el-form-item>
              </div>
              <div class="sm">字段名称支持填写中文，英文，不支持特殊符号</div>
            </div>
            <div class="footer">
              <el-button type="primary" class="cancel" @click="cancelDialog">取&nbsp;&nbsp;消</el-button>
              <el-button type="primary" class="confirm" @click="confirmDialog('modifyFieldForm')">
                确&nbsp;&nbsp;定</el-button>
            </div>
          </el-form>
        </div>
      </el-dialog>
    </template>
    <!-- <template v-else>
      <div class="adminName">{{fieldName}}</div>
    </template> -->
  </h6>
</template>
<script>
  import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions,
  } from 'vuex'
  import bus from '@/assets/js/bus'
  import busType from '@/assets/js/busType'

  export default {
    name: 'editpage',
    mixins: [],
    props: {
      tname: String,
      tkey: String,
      tcode: String
    },
    data() {
      return {
        visibility: false,
        addFiledsData: [{
          title: this.fieldName
        }],
        fieldName: '',
        form: {
          newFieldName: '',
          newFieldCode: ''
        },
        rules: {
          // newFieldName: [
          //     { validator: this.checkFieldName, trigger: ['blur', 'change'] }
          // ],
        },
        visible: false
      }
    },
    computed: {
      ...mapState(['labelState']),
      ...mapGetters(['roleState', 'userType']),
    },
    components: {},
    watch: {
      tname() {
        this.fieldName = this.tname;
        this.form.newFieldName = this.tname;
      },
      tcode() {
        this.form.newFieldCode = this.tcode;
      },
    },
    mounted() {
      this.fieldName = this.tname;
      this.form.newFieldName = this.tname;
      this.form.newFieldCode = this.tcode;
    },
    destroyed() { },
    methods: {
      editFild() {
        this.visibility = true;
      },
      addCancelDialog() {
        this.visibility = false;
      },
      cancelDialog() {
        this.visibility = false;
      },
      confirmDialog(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.changeName();
          } else {
            //console.log('error submit!!');
            return false;
          }
        });

      },
      checkFieldName(rule, value, callback) {
        if (value.trim() === '') {
          callback(new Error('字段名称不能为空'))
        }
        if (value.includes('/')) {
          callback(new Error('请输入中文，英文，不支持特殊符号'))
        }
        callback();
      },
      changeName() {
        let url = this.$resource.updateFieldName.
          replace('{templateId}', this.$route.query.ruleId) + '?key=' + this.tkey + '&newName=' + encodeURIComponent(this.form.newFieldName)

        this.$axios({
          url: url,
          method: 'get'
        }).then(res => {
          this.$message.success('修改字段名称成功');
          this.visibility = false;

          this.$emit('on-success');
        }).catch(e => {
          console.log(e)
        })
      }

    }
  };
</script>
<style>
  h6.modifyFieldName {
    font-size: 14px;
    color: var(--color-d4);
    padding-left: 30px;

    .name {
      font-size: 14px;
      cursor: pointer;
    }

    .adminName {
      font-size: 14px;
    }

    .icon-editfield {
      margin: 0 0 0 5px;
      width: 20px;
      height: 20px;
      display: inline-block;
      line-height: 20px;
      text-align: center;
      display: none;
    }

    .icon-editfield:before {
      color: #3D7FFF;
    }
  }

  .changeNamePop {
    .content {
      display: flex;
      align-items: center;
    }

    .el-button {
      margin-left: 10px;
    }

    .el-input {}

    .el-input__inner {
      width: 240px;
    }

    .el-input__inner:focus {
      background: transparent;
      border: 1px solid var(--color-title);
    }
  }
</style>